import { useState } from 'react';
import { useStableCallback } from '@shape-construction/hooks';

export type PaginationCursor = string | null;

export type UsePaginationProps = {
  pageSize?: number;
};

export const usePagination = ({ pageSize }: UsePaginationProps = {}) => {
  const [{ after, before }, setState] = useState<{
    after?: PaginationCursor;
    before?: PaginationCursor;
  }>({});

  const onNext = useStableCallback((cursor: PaginationCursor) => setState({ after: cursor }));
  const onPrevious = useStableCallback((cursor: PaginationCursor) => setState({ before: cursor }));
  const reset = useStableCallback(() => setState({}));

  return { onNext, onPrevious, reset, after: after ?? undefined, before: before ?? undefined, pageSize };
};
